import React from "react";
import clsx from "clsx";

const getGridColsClass = (cols) => {
  const map = {
    1: "grid-cols-1",
    2: "grid-cols-2",
    3: "grid-cols-3",
    4: "grid-cols-4",
    5: "grid-cols-5",
    6: "grid-cols-6",
  };
  return map[cols] || "grid-cols-1";
};

const getGridRowsClass = (rows) => {
  const map = {
    1: "grid-rows-1",
    2: "grid-rows-2",
    3: "grid-rows-3",
    4: "grid-rows-4",
    5: "grid-rows-5",
    6: "grid-rows-6",
  };
  return map[rows] || ""; // Fallback to auto rows
};

const Loader = ({
  count = 1,
  columns = 1,
  rows, // NEW
  height = "h-32",
  width = "w-auto",
  rounded = "rounded-lg",
  layout = "grid",
  gap = "gap-2",
  wrapperClass = "",
  itemClass = "",
}) => {
  const skeletonItems = Array.from({ length: count }).map((_, index) => (
    <div
      key={index}
      className={clsx("skeleton", height, width, rounded, itemClass)}
    />
  ));

  const layoutClass =
    layout === "grid"
      ? clsx("grid", getGridColsClass(columns), getGridRowsClass(rows), gap)
      : clsx("flex", "flex-wrap", gap);

  return <div className={clsx(wrapperClass, layoutClass)}>{skeletonItems}</div>;
};

export default Loader;
